const labelTranslations: Record<string, Record<string, string>> = {
    account_number: {
        en: "Account Number",
        si: "ගිණුම් අංකය",
        ta: "கணக்கு எண்"
    },
    customer_number: {
        en: "Customer Number",
        si: "ගනුදෙනුකාර අංකය",
        ta: "வாடிக்கையாளர் எண்"
    },
    account_type_name: {
        en: "Account Type",
        si: "ගිණුම් වර්ගය",
        ta: "கணக்கு வகை"
    },
    customer_address: {
        en: "Address",
        si: "ලිපිනය",
        ta: "முகவரி"
    },
    address_ln1: {
        en: "Address Line 1",
        si: "ලිපිනය පේළිය 1",
        ta: "முகவரி வரி 1"
    },
    address_ln2: {
        en: "Address Line 2",
        si: "ලිපිනය පේළිය 2",
        ta: "முகவரி வரி 2"
    },
    address_ln3: {
        en: "Address Line 3",
        si: "ලිපිනය පේළිය 3",
        ta: "முகவரி வரி 3"
    },
    customer_mobile_number: {
        en: "Mobile Number",
        si: "ජංගම දුරකථන අංකය",
        ta: "கைபேசி எண்"
    },
    mobile_1: {
        en: "Mobile Number 1",
        si: "ජංගම දුරකථන 1",
        ta: "கைபேசி எண் 1"
    },
    mobile_2: {
        en: "Mobile Number 2",
        si: "ජංගම දුරකථන 2",
        ta: "கைபேசி எண் 2"
    },
    customer_nic: {
        en: "NIC Number",
        si: "ජා.හැ. අංකය",
        ta: "தேசிய அடையாள அட்டை எண்"
    },
    nic: {
        en: "NIC Number",
        si: "ජා.හැ. අංකය",
        ta: "தேசிய அடையாள அட்டை எண்"
    },
    open_date: {
        en: "Date",
        si: "දිනය",
        ta: "தேதி"
    },
    closing_date: {
        en: "Maturity Date",
        si: "කල්පිරෙන දිනය",
        ta: "முதிர்வு தேதி"
    },
    nominee_name: {
        en: "Nominee Name",
        si: "නම් කළ තැනැත්තාගේ නම",
        ta: "பரிந்துரைக்கப்பட்டவர் பெயர்"
    },
    balance: {
        en: "Balance",
        si: "ශේෂය",
        ta: "மீதி"
    },
    balance_words: {
        en: "Balance in Words",
        si: "ශේෂය වචනයෙන්",
        ta: "மீதி எழுத்தில்"
    },
    period: {
        en: "Period",
        si: "කාලසීමාව",
        ta: "காலம்"
    },
    invoice_date: {
        en: "Invoice Date",
        si: "ඉන්වොයිසි දිනය",
        ta: "கணக்கொப்பி தேதி"
    },
    credit_period: {
        en: "Credit Period",
        si: "ණය කාලසීමාව",
        ta: "கடன் காலம்"
    },
    note: {
        en: "Note",
        si: "සටහන",
        ta: "குறிப்பு"
    },
    interest_rate: {
        en: "Interest Rate",
        si: "පොලී අනුපාතිකය",
        ta: "வட்டி விகிதம்"
    },
    quantity: {
        en: "Quantity",
        si: "ප්‍රමාණය",
        ta: "அளவு"
    },
    carat: {
        en: "Carat",
        si: "කැරට්",
        ta: "காரட்"
    },
    weight_gram: {
        en: "Weight (g)",
        si: "බර (ග්‍රෑම්)",
        ta: "எடை (கிராம்)"
    },
    gold_weight_gram: {
        en: "Gold Weight (g)",
        si: "රන් බර (ග්‍රෑම්)",
        ta: "தங்க எடை (கிராம்)"
    },
    accessed_value: {
        en: "Assessed Value",
        si: "තක්සේරු වටිනාකම",
        ta: "மதிப்பிடப்பட்ட மதிப்பு"
    },
    accessed_value_words: {
        en: "Assessed Value in Words",
        si: "තක්සේරු වටිනාකම වචනයෙන්",
        ta: "மதிப்பிடப்பட்ட மதிப்பு எழுத்தில்"
    },
    description: {
        en: "Description",
        si: "විස්තරය",
        ta: "விளக்கம்"
    },
    market_value: {
        en: "Market Value",
        si: "වෙළඳපල වටිනාකම",
        ta: "சந்தை மதிப்பு"
    },
    market_value_words: {
        en: "Market Value in Words",
        si: "වෙළඳපල වටිනාකම වචනයෙන්",
        ta: "சந்தை மதிப்பு எழுத்தில்"
    },
    capital: {
        en: "Capital",
        si: "ප්‍රාග්ධනය",
        ta: "மூலதனம்"
    },
    capital_words: {
        en: "Capital in Words",
        si: "ප්‍රාග්ධනය වචනයෙන්",
        ta: "மூலதனம் எழுத்தில்"
    },
    interest: {
        en: "Interest",
        si: "පොලිය",
        ta: "வட்டி"
    },
    interest_words: {
        en: "Interest in Words",
        si: "පොලිය වචනයෙන්",
        ta: "வட்டி எழுத்தில்"
    },
    institute_name: {
        en: "Institute Name",
        si: "ආයතනයේ නම",
        ta: "நிறுவனத்தின் பெயர்"
    },
    institute_address: {
        en: "Institute Address",
        si: "ආයතනයේ ලිපිනය",
        ta: "நிறுவனத்தின் முகவரி"
    },
    institute_phone_number: {
        en: "Institute Phone Number",
        si: "ආයතනයේ දුරකථන අංකය",
        ta: "நிறுவனத்தின் தொலைபேசி எண்"
    },
    institute_email: {
        en: "Institute Email",
        si: "ආයතනයේ විද්‍යුත් තැපෑල",
        ta: "நிறுவனத்தின் மின்னஞ்சல்"
    },
    institute_reg_num: {
        en: "Institute Registration No",
        si: "ආයතන ලියාපදිංචි අංකය",
        ta: "நிறுவனத்தின் பதிவு எண்"
    },
    institute_reg_date: {
        en: "Institute Registration Date",
        si: "ආයතන ලියාපදිංචි දිනය",
        ta: "நிறுவனத்தின் பதிவு தேதி"
    },
    branch_name: {
        en: "Branch Name",
        si: "ශාඛාවේ නම",
        ta: "கிளையின் பெயர்"
    },
    branch_address: {
        en: "Branch Address",
        si: "ශාඛාවේ ලිපිනය",
        ta: "கிளையின் முகவரி"
    },
    branch_telephone_number: {
        en: "Branch Telephone Number",
        si: "ශාඛාවේ දුරකථන අංකය",
        ta: "கிளையின் தொலைபேசி எண்"
    },
    branch_email: {
        en: "Branch Email",
        si: "ශාඛාවේ විද්‍යුත් තැපෑල",
        ta: "கிளையின் மின்னஞ்சல்"
    },
    transaction_type: {
        en: "Transaction Type",
        si: "ගනුදෙනු වර්ගය",
        ta: "பரிவர்த்தனை வகை"
    },
    customer_name: {
        en: "Customer Name",
        si: "ගනුදෙනුකරුගේ නම",
        ta: "வாடிக்கையாளர் பெயர்"
    },
    title: {
        en: "Customer Title",
        si: "ගනුදෙනුකරුගේ ගෞරව නාමය",
        ta: "வாடிக்கையாளர் தலைப்பு"
    },
    full_name: {
        en: "Customer Full Name",
        si: "ගනුදෙනුකරුගේ සම්පූර්ණ නම",
        ta: "வாடிக்கையாளர் முழு பெயர்"
    },
    ini_name: {
        en: "Customer Name with Initials",
        si: "මුලකුරු සමඟ ගනුදෙනුකරුගේ නම",
        ta: "முதலெழுத்துக்களுடன் வாடிக்கையாளர் பெயர்"
    },
    address: {
        en: "Customer Address",
        si: "ගනුදෙනුකරුගේ ලිපිනය",
        ta: "வாடிக்கையாளர் முகவரி"
    },
    full_name_ln1: {
        en: "Full Name Line 1",
        si: "සම්පූර්ණ නම පේළිය 1",
        ta: "முழு பெயர் வரி 1"
    },
    full_name_ln2: {
        en: "Full Name Line 2",
        si: "සම්පූර්ණ නම පේළිය 2",
        ta: "முழு பெயர் வரி 2"
    },
    full_name_ln3: {
        en: "Full Name Line 3",
        si: "සම්පූර්ණ නම පේළිය 3",
        ta: "முழு பெயர் வரி 3"
    },
    ini_name_ln1: {
        en: "Name with Initials Line 1",
        si: "මුලකුරු සමඟ නම පේළිය 1",
        ta: "பெயரின் முதலெழுத்துக்கள் வரி 1"
    },
    ini_name_ln2: {
        en: "Name with Initials Line 2",
        si: "මුලකුරු සමඟ නම පේළිය 2",
        ta: "பெயரின் முதலெழுத்துக்கள் வரி 2"
    },
    ini_name_ln3: {
        en: "Name with Initials Line 3",
        si: "මුලකුරු සමඟ නම පේළිය 3",
        ta: "பெயரின் முதலெழுத்துக்கள் வரி 3"
    },
    transaction_number: {
        en: "Transaction No",
        si: "ගනුදෙනු අංකය",
        ta: "பரிவர்த்தனை எண்"
    },
    total_amount: {
        en: "Total Amount",
        si: "මුළු මුදල",
        ta: "மொத்த தொகை"
    },
    total_amount_words: {
        en: "Total Amount in Words",
        si: "මුළු මුදල වචනයෙන්",
        ta: "மொத்த தொகை எழுத்தில்"
    },
    date: {
        en: "Date",
        si: "දිනය",
        ta: "தேதி"
    },
    reprint: {
        en: "RE-PRINT",
        si: "ප්‍රති-මුද්‍රණය",
        ta: "மறுபதிப்பு"
    },
    print_time: {
        en: "Print Time",
        si: "මුද්‍රණ වේලාව",
        ta: "அச்சு நேரம்"
    },
    print_date: {
        en: "Print Date",
        si: "මුද්‍රණ දිනය",
        ta: "அச்சு தேதி"
    },
    entered_by_id: {
        en: "Entered By ID",
        si: "ඇතුළත් කළ පරිශීලක හැඳුනුම්පත",
        ta: "உள்ளிடப்பட்ட பயனர் ஐடி"
    },
    c_by: {
        en: "Created By ID",
        si: "නිර්මාණය කළ පරිශීලක හැඳුනුම්පත",
        ta: "உருවාக்கிய பயனர் ஐடி"
    },
    c_by_name: {
        en: "Created By Name",
        si: "නිර්මාණය කළ පරිශීලකයාගේ නම",
        ta: "உருவாக்கிய பயனர் பெயர்"
    },
    voucher_number: {
        en: "Voucher Number",
        si: "වවුචර් අංකය",
        ta: "வவுச்சர் எண்"
    },
    name: {
        en: "Name/Description",
        si: "නම/විස්තරය",
        ta: "பெயர்/விளக்கம்"
    },
    guarantor_members: {
        en: "Guarantors",
        si: "ඇපකරුවන්",
        ta: "உத்தரவாதம் அளிப்பவர்கள்"
    }
};

export const getFieldLabel = (fieldId: string, lang: string, printConfig?: any): string => {
    const baseField = fieldId.replace(/_copy_\d+$/, "");
    let isTranslate = true;
    if (printConfig && typeof printConfig === 'object') {
        if (printConfig.fields && printConfig.fields[fieldId]) {
            if (printConfig.fields[fieldId].label_translate !== undefined) {
                isTranslate = Boolean(printConfig.fields[fieldId].label_translate);
            }
        } else if (printConfig[fieldId] && printConfig[fieldId].label_translate !== undefined) {
            isTranslate = Boolean(printConfig[fieldId].label_translate);
        } else if (printConfig[baseField] && printConfig[baseField].label_translate !== undefined) {
            isTranslate = Boolean(printConfig[baseField].label_translate);
        }
    }

    const targetLang = isTranslate ? lang : "en";
    const cleanLang = targetLang.startsWith("si") ? "si" : targetLang.startsWith("ta") ? "ta" : "en";
    
    // Check for custom override in printConfig
    if (printConfig && typeof printConfig === 'object') {
        // Check transaction receipt format first
        if (printConfig.fields && printConfig.fields[fieldId]) {
            const customVal = printConfig.fields[fieldId][`label_${cleanLang}`];
            if (customVal !== undefined && customVal !== null && String(customVal).trim() !== "") {
                return String(customVal);
            }
        }
        // Check print policy format
        const customVal = printConfig[`${fieldId}_label_${cleanLang}`];
        if (customVal !== undefined && customVal !== null && String(customVal).trim() !== "") {
            return String(customVal);
        }
    }

    const entry = labelTranslations[baseField];
    if (entry && entry[cleanLang]) {
        return entry[cleanLang];
    }
    
    // Fallback: convert snake_case to Title Case (using baseField)
    return baseField
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
};
